import { removeMark } from '@atlaskit/editor-common/mark';
import { ACTIONS, pluginKey } from '../main';
export var removeColor = function removeColor() {
  return function (state, dispatch) {
    var schema = state.schema;
    var textColor = schema.marks.textColor;
    var tr = state.tr;
    removeMark(textColor)({
      tr: tr
    });
    if (dispatch) {
      dispatch(tr.setMeta(pluginKey, {
        action: ACTIONS.RESET_COLOR
      }));
    }
    return true;
  };
};